import { render, staticRenderFns } from "./ViaticApproveModal.vue?vue&type=template&id=6fab0ff6"
import script from "./ViaticApproveModal.vue?vue&type=script&lang=js"
export * from "./ViaticApproveModal.vue?vue&type=script&lang=js"
import style0 from "./ViaticApproveModal.vue?vue&type=style&index=0&id=6fab0ff6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports